module.exports = __webpack_public_path__ + "img/faq5_1-md.441aae88.png";